import { render } from "./a-bamboo.vue?vue&type=template&id=59b11804&scoped=true"
import script from "./a-bamboo.vue?vue&type=script&lang=js"
export * from "./a-bamboo.vue?vue&type=script&lang=js"

import "./a-bamboo.vue?vue&type=style&index=0&id=59b11804&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b11804"]])

export default __exports__